import React, { useState } from 'react';
import { Search, MessageSquare, Clock, CheckCircle2, AlertCircle, ChevronRight, Info } from 'lucide-react';
import { motion } from 'framer-motion';
const orders = [{
  id: 'ORD-7721',
  customer: 'Global Tech',
  service: 'Enterprise SaaS',
  status: 'In Progress',
  date: '2h ago'
}, {
  id: 'ORD-7720',
  customer: 'Abuja Hub',
  service: 'Design Package',
  status: 'Completed',
  date: '5h ago'
}, {
  id: 'ORD-7719',
  customer: 'Lagos Fin',
  service: 'Custom Dev',
  status: 'Pending',
  date: '1d ago'
}];
export function Orders() {
  const [activeTab, setActiveTab] = useState('active');
  const [selectedOrder, setSelectedOrder] = useState(orders[0]);
  return <div className="space-y-6 max-w-[1600px] mx-auto h-full flex flex-col" data-id="element-1459">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1460">
        <div data-id="element-1461">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1462">
            Fulfillment Requests
          </h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1463">
            Manage active orders and monitor Shadow Support logs.
          </p>
        </div>
        <div className="flex gap-2 bg-gray-50 p-1 rounded-lg border border-gray-200" data-id="element-1464">
          {['active', 'completed', 'support'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-1.5 text-xs font-bold rounded-md transition-all ${activeTab === tab ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-1465">
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>)}
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-6 min-h-0" data-id="element-1466">
        {/* Order List */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden" data-id="element-1467">
          <div className="p-4 border-b border-gray-100" data-id="element-1468">
            <div className="relative" data-id="element-1469">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} data-id="element-1470" />
              <input type="text" placeholder="Search orders..." className="w-full pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20" data-id="element-1471" />
            </div>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-1472">
            {orders.map(order => <button key={order.id} onClick={() => setSelectedOrder(order)} className={`w-full p-4 flex items-center justify-between border-b border-gray-50 transition-colors ${selectedOrder.id === order.id ? 'bg-indigo-50/50' : 'hover:bg-gray-50'}`} data-id="element-1473">
                <div className="text-left" data-id="element-1474">
                  <p className="text-sm font-bold text-slate-900" data-id="element-1475">{order.id}</p>
                  <p className="text-xs text-gray-500 font-medium" data-id="element-1476">
                    {order.customer}
                  </p>
                </div>
                <div className="text-right" data-id="element-1477">
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${order.status === 'Completed' ? 'bg-emerald-50 text-emerald-600' : order.status === 'In Progress' ? 'bg-indigo-50 text-indigo-600' : 'bg-amber-50 text-amber-600'}`} data-id="element-1478">
                    {order.status}
                  </span>
                  <p className="text-[10px] text-gray-400 font-bold mt-1" data-id="element-1479">
                    {order.date}
                  </p>
                </div>
              </button>)}
          </div>
        </div>

        {/* Shadow Support View */}
        <div className="lg:col-span-2 bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden" data-id="element-1480">
          <div className="p-4 border-b border-gray-100 flex items-center justify-between bg-gray-50/50" data-id="element-1481">
            <div className="flex items-center gap-3" data-id="element-1482">
              <div className="p-2 bg-white rounded-lg shadow-sm" data-id="element-1483">
                <MessageSquare size={18} className="text-indigo-600" data-id="element-1484" />
              </div>
              <div data-id="element-1485">
                <h3 className="text-sm font-bold text-slate-900" data-id="element-1486">
                  Shadow Support Log: {selectedOrder.id}
                </h3>
                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest" data-id="element-1487">
                  Partner Visibility Mode
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-indigo-50 text-indigo-600 rounded-lg text-[10px] font-bold" data-id="element-1488">
              <CheckCircle2 size={12} data-id="element-1489" />
              SLA: 99.9% Uptime
            </div>
          </div>

          <div className="p-4 bg-blue-50 border-b border-blue-100 flex gap-3" data-id="element-1490">
            <Info size={18} className="text-blue-600 shrink-0" data-id="element-1491" />
            <p className="text-xs text-blue-700 leading-relaxed" data-id="element-1492">
              <strong data-id="element-1493">Partner Branding Active:</strong> The customer sees your
              brand name ("MyReseller Pro") as the support agent. The Abuja
              Support Team is operating under your white-label identity.
            </p>
          </div>

          <div className="flex-1 p-6 space-y-6 overflow-y-auto bg-gray-50/30" data-id="element-1494">
            <div className="flex gap-4" data-id="element-1495">
              <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-[10px] font-bold" data-id="element-1496">
                GT
              </div>
              <div className="space-y-1 max-w-[70%]" data-id="element-1497">
                <div className="bg-white p-3 rounded-lg rounded-tl-none border border-gray-100 shadow-sm" data-id="element-1498">
                  <p className="text-sm text-slate-700" data-id="element-1499">
                    Hi, we are seeing some latency on our Lagos node. Can you
                    check?
                  </p>
                </div>
                <p className="text-[10px] text-gray-400 font-bold" data-id="element-1500">
                  Customer • 10:42 AM
                </p>
              </div>
            </div>

            <div className="flex gap-4 flex-row-reverse" data-id="element-1501">
              <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center text-[10px] font-bold text-white" data-id="element-1502">
                MR
              </div>
              <div className="space-y-1 max-w-[70%] text-right" data-id="element-1503">
                <div className="bg-indigo-600 p-3 rounded-lg rounded-tr-none shadow-sm text-white" data-id="element-1504">
                  <p className="text-sm" data-id="element-1505">
                    Checking the Lagos infrastructure now. One moment while I
                    run a diagnostic on the EPYC server.
                  </p>
                </div>
                <p className="text-[10px] text-gray-400 font-bold" data-id="element-1506">
                  MyReseller Pro (Abuja Team) • 10:45 AM
                </p>
              </div>
            </div>
          </div>

          <div className="p-4 border-t border-gray-100 bg-white" data-id="element-1507">
            <div className="flex gap-3" data-id="element-1508">
              <input type="text" placeholder="Intervene in chat..." className="flex-1 px-4 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500/20" data-id="element-1509" />
              <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-bold shadow-lg shadow-indigo-500/20" data-id="element-1510">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}